import httpService from "@/services/httpService";
import {baseUrl} from "@/config"
import store from '../store'
import {SET_ACCOUNT, SET_ORGANIZATION, SET_PORTAL_WEB_SETTINGS} from "@/store/mutation-types";
import router from "@/router";
import {auth} from "@/main";
import * as pendo from "@pendo/web-sdk";
import {organizationBusinessTypeIds} from "@/js/shared/constants";

const endpoint = baseUrl + "/account"
let tempEndpoint = baseUrl + "/account"

const accountModel = {
    id: 0,
    organizationId: 0,
    organizationName: "string",
    email: "string",
    password: "string",
    firstName: "string",
    lastName: "string",
    phoneNumber: "string",
    jobTitle: "string",
    resetToken: "string",
    professionalTypeId: 0,
    isDisabled: false,
    isAdmin: true,
    isSafetyCoach: false,
    accountTypeId: 1
}

const updateAccountModel = {
    id: 0,
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    jobTitle: "",
    professionalTypeId: 0,
    isDisabled: false,
    isSafetyCoach: false,
    isBillingContact: false,
    accountTypeId: 1,
    organizationAccessTypeId: 1,
    groupIds: [
        0
    ]
}

const updateAccountGroupsModel = {
    id: 0,
    groupIds: [
        0
    ]
}

const newAccountModel = {
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    jobTitle: "",
    professionalTypeId: 0,
    isDisabled: false,
    isSafetyCoach: false,
    isBillingContact: false,
    accountTypeId: 1,
    organizationAccessTypeId: 1,
    groupIds: []

}

const updateAccountPasswordModel = {
    id: 0,
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    jobTitle: "",
    professionalTypeId: 0,
    isDisabled: false,
    isSafetyCoach: false,
    accountTypeId: 1,
    organizationAccessTypeId: 1,
    groupIds: [
        0
    ],
    updateGroups: false,
    oldPassword: "",
    newPassword: ""
}

const getloginmethod = async (email) => {
    try {
        const response = await httpService.post(tempEndpoint + '/GetLoginMethod', {email});
        return response;
    } catch {

    }
}

const samllogin = async () => {
    try {
        const response = await httpService.post(tempEndpoint + '/samllogin');
        
        return await saveStuffFromLogin(response, "SamlSso");
    } catch {

    }
}

const ssologin = async (token) => {
    try {
        if (token)
            httpService.setAuthTokenHeader(token)
        const response = await httpService.post(tempEndpoint + '/ssologin');

        return await saveStuffFromLogin(response, "OAuthSso");
    } catch (ex) { }
}

const login = async (email, password) => {
    try {
        let response = await httpService.post(tempEndpoint + '/login', {email, password});

        response = await saveStuffFromLogin(response, "SwayUsernamePassword");
        httpService.setAuthTokenHeader(response.token)
        return response
    } catch {

    }
}

// Coalesce concurrent switchSelectedOrganization calls for the same target org.
// Without this, the http interceptor fires one switch per in-flight request that sees
// a URL/storage mismatch during a transition, producing 10+ duplicate POSTs.
const _inFlightSwitches = new Map();

const switchSelectedOrganization = async (organizationId, router) => {
    const key = String(organizationId);
    if (_inFlightSwitches.has(key)) {
        return _inFlightSwitches.get(key);
    }

    // Snapshot current org before clearing so we can restore it if the switch fails.
    const prevOrg = sessionStorage.getItem("selectedOrganization");
    const prevOrgId = sessionStorage.getItem("selectedOrganizationId");

    // Clear the cached org snapshot so anything that reads sessionStorage during the
    // switch window doesn't see the previous org (e.g. an enterprise org bleeding into
    // a non-enterprise destination). saveStuffFromLogin repopulates these on success.
    sessionStorage.removeItem("selectedOrganization");
    sessionStorage.removeItem("selectedOrganizationId");

    const restorePrevOrg = () => {
        if (prevOrg) sessionStorage.setItem("selectedOrganization", prevOrg);
        if (prevOrgId) sessionStorage.setItem("selectedOrganizationId", prevOrgId);
    };

    const promise = (async () => {
        try {
            const response = await httpService.post(endpoint + '/SwitchSelectedOrganization', {organizationId});
            const result = await saveStuffFromLogin(response);
            if (!result) restorePrevOrg();
            // Re-scope Pendo to the newly-selected org without re-initializing the
            // session. The visitor stays the same person; only the account context
            // changes. No-op if Pendo wasn't initialized (e.g. post-refresh flows).
            setPendoAccount(store.state.currentAccount, store.state.currentOrganization);
            return result;
        } catch {
            restorePrevOrg();
            return undefined;
        }
    })();

    _inFlightSwitches.set(key, promise);
    // Clear the entry once the call settles so a future legitimate switch can run.
    promise.finally(() => _inFlightSwitches.delete(key));

    return promise;
}

const verifyMfaCode = async (request) => {
    try {
        const response = await httpService.post(tempEndpoint + '/VerifyMfaCode', request)
        
        if (response)
            httpService.setAuthTokenHeader(response.token)
        
        return await saveStuffFromLogin(response, "SwayUsernamePassword");
    } catch {

    }
}

const getMobileToken = async (request) => {
    try {
        const response = await httpService.post(tempEndpoint + '/GetMobileToken', request);

        return response;
    } catch {

    }
}

const saveStuffFromLogin = async (response, authSource) => {
    if (response && response.isSuccess) {
        // Backend signals "user can't access requested org" by returning a successful
        // response with selectedOrganization = null. Don't touch storage — the caller
        // (router guard or http interceptor) handles navigation to the not-found page.
        if (!response.selectedOrganization) {
            return response;
        }
        console.log("response");
        const {account, token, hasMultipleOrganizations, availableOrganizations, selectedOrganization, viewingAsSuper, portalWebSettings} = response;
        localStorage.setItem("jwtToken", token);

        account.availableOrganizations = availableOrganizations;
        account.hasMultipleOrganizations = hasMultipleOrganizations;

        if (selectedOrganization)
            selectedOrganization.viewingAsSuper = viewingAsSuper;
        account.selectedOrganization = null; //no longer tied to account
        account.viewingAsSuper = null; //no longer tied to account

        sessionStorage.setItem("selectedOrganization", JSON.stringify(selectedOrganization))
        sessionStorage.setItem("selectedOrganizationId", selectedOrganization.id)
        localStorage.setItem("selectedOrganizationId", selectedOrganization.id)

        store.commit(SET_ACCOUNT, account);
        if (account){
            store.commit(SET_ORGANIZATION, selectedOrganization)
        }
        if (portalWebSettings){
            store.commit(SET_PORTAL_WEB_SETTINGS, portalWebSettings)
        }
        
        if (authSource)
            localStorage.setItem("authenticationSourceType", authSource);
        httpService.setSelectedOrgId(selectedOrganization.id);
        localStorage.setItem('user', JSON.stringify(account))
        //httpService.setAuthTokenHeader(token)

        return response;
    }
}

// Pendo visitor/account identification. Called once user lands in a fully-authenticated
// state (post-MFA, post-SSO callback), and from App.mounted on every page load that
// rehydrates a stored identity (so refresh / new-tab / deep-link loads keep tracking).
let _pendoInitialized = false;

//   visitor.full_name      — Pendo's standard property; we concatenate first + last.
//   account.name           — Pendo's standard property; the org's display name.
//   account.business_type  — custom property usable as a Pendo Segment
const buildPendoPayload = (account, organization) => {
    const fullName = `${account?.firstName ?? ''} ${account?.lastName ?? ''}`.trim();
    const businessTypeMatch = organizationBusinessTypeIds.find(x => x.id === organization?.businessTypeId);

    const visitor = { id: account.id };
    if (fullName) visitor.full_name = fullName;

    const accountPayload = { id: organization.id };
    if (organization?.name) accountPayload.name = organization.name;
    if (businessTypeMatch) accountPayload.business_type = businessTypeMatch.label;

    return { visitor, account: accountPayload };
}

const initializePendo = async (account, organization) => {
    if (!account || !organization) return;
    if (_pendoInitialized) {
        setPendoAccount(account, organization);
        return;
    }
    try {
        await pendo.initialize({
            apiKey: 'fabc12f2-d115-41a9-a8bc-c5775c956c6e',
            env: 'io',
            ...buildPendoPayload(account, organization),
        });
        _pendoInitialized = true;
    }
    catch (e) {
        // Swallow — Pendo init failures shouldn't block the post-login flow.
    }
}

// Re-scope an already-initialized Pendo session to a different account (org) without
// re-running initialize. Used when the user switches orgs — same visitor, new account
// context. No-op if Pendo wasn't initialized this page load (e.g. user landed on a
// route via refresh without going through finishLogin); identify will throw and we
// silently swallow it.
const setPendoAccount = (account, organization) => {
    if (!account || !organization) return;
    try {
        pendo.identify(buildPendoPayload(account, organization));
    }
    catch (e) {
        // Swallow — Pendo not initialized, or visitor/account update failed.
    }
}

// for when the user updates the myAccount page
const updateAccountInStorage = newAccount => {
    let currentObject = getUserFromBrowserStorage();
    let keys = Object.keys(newAccount);
    // 
    keys.forEach(key => {
        if (key in currentObject) {
            currentObject[key] = newAccount[key]
        }
        
    })
    
    localStorage.setItem('user', JSON.stringify(currentObject))
    store.commit(SET_ACCOUNT, currentObject)
}

const updateAccount = async (request) => {
    try {
        return await httpService.post(endpoint + '/UpdateAccount', request)

        
    } catch {

    }
}

const updateAccountGroups = async (request) => {
    try {
        return await httpService.post(endpoint + '/UpdateAccountGroups', request)


    } catch {

    }
}

const updateAccountOrganization = async (request) => {
    try {
        return await httpService.post(endpoint + '/UpdateAccountOrganization', request)


    } catch {

    }
}

const requestMfaCode = async (request) => {
    try {
        return await httpService.post(tempEndpoint + '/RequestMfaCode', request)


    } catch {

    }
}

const forgotPassword = async (request) => {
    try {
        return await httpService.postPublic(endpoint + '/ForgotPassword', request)


    } catch {

    }
}

const resetPassword = async (request) => {
    try {
        return await httpService.postPublic(endpoint + '/ResetPassword', request)


    } catch {

    }
}

const updatePassword = async (request) => {
    try {
        return await httpService.post(endpoint + '/UpdatePassword', request)

        
    } catch {

    }
}

const refreshToken = async () => {
    
    try {
        //set and update a localstorage item of the time here and only continue if it's been more than 30 seconds since the last refresh
        if (localStorage.getItem('lastRefresh') && (new Date() - new Date(localStorage.getItem('lastRefresh'))) / 1000 < 30) 
            return;
        
        localStorage.setItem('lastRefresh', new Date())

        let response = await httpService.post(endpoint + '/RefreshToken')
        
        if (response && response.isSuccess){
            localStorage.setItem('jwtToken', response.token);
            httpService.setAuthTokenHeader(response.token)
        }
        
        return response;
    } catch {

    }
}

const deleteAccount = async (id) => {
    try {
        return await httpService.post(endpoint + '/DeleteAccount', {id})


    } catch {

    }
}

const createAccount = async (request) => {
    try {
        const response = await httpService.post(endpoint + '/CreateAccount', request)
        return response
    } catch {

    }
}

const createParentAccount = async (request) => {
    try {
        const response = await httpService.post(endpoint + '/CreatePatientAccount', request)
        return response
    } catch {

    }
}

const getProfilesForAccount = async () => {
    try {
        return await httpService.post(endpoint + '/GetProfilesForAccount' )
    } catch (e) {

    }
}

const getAccounts = async () => {
    try {
        return await httpService.post(endpoint + '/GetAccounts' )
    } catch (e) {

    }
}

const getAccount = async (id) => {
    try {
        return await httpService.post(endpoint + '/GetAccount', {id} )

    } catch (e) {

    }
}

const checkEmailAddress = async (email) => {
    try {
        return await httpService.post(endpoint + '/CheckEmailAddress', {email} )

    } catch (e) {

    }
}

const logout = (noReturnUrl = false) => {
    clearLogin();

    const alreadyAtLogin = location.pathname === '/login' || location.pathname === '/';
    let redirect = (noReturnUrl || alreadyAtLogin) ? null : (location.pathname + location.search).substr(1);

    router.push(`/login${redirect ? '?redirect=' + redirect : ''}`);
}

// logoutTimeout is called by the 401 interceptor. It skips auth.logout() so the browser
// does not redirect through Microsoft's SAML sign-out endpoint — that round-trip is only
// appropriate when the user intentionally signs out. On a session timeout we just clear
// local state and push to /login directly.
const logoutTimeout = () => {
    clearLogin(false);
    router.push('/login');
}

const clearLogin = (doMsalLogout = true) => {
    try {
        if (doMsalLogout && auth.getAllAccounts().length > 0)
            auth.logout(); // logout of OAuth
    }
    catch (ex){
        // do nothing
    }

    // do single logout before deleting cookies
    try {
        //alert("trying auth source")
        var authSource = localStorage.getItem('authenticationSourceType');
        if (authSource){
            localStorage.removeItem('authenticationSourceType');
            if (authSource == "SamlSso"){
                let url = baseUrl + "/saml/InitiateSingleLogout";
                httpService.post(url).then(value => {});
            }
        }
    }
    catch (ex) {
        // do nothing
    }

    try {
        localStorage.removeItem('user');
        localStorage.removeItem('jwtToken');
    }
    catch (ex) {
        // do nothing
    }

    // retrieve all cookies
    try {
        var cookies = document.cookie.split(';');
        // set past expiry to all cookies
        for (var i = 0; i < cookies.length; i++) {
            document.cookie = cookies[i] + "=; expires="+ new Date(0).toUTCString();
        }
    }
    catch (ex) {
        // do nothing
    }

    try {
        httpService.removeAuthTokenHeader();
    }
    catch (ex) {
        // do nothing
    }
}

const getUserFromBrowserStorage = () => {
    let user = localStorage.getItem('user');
    if (!user) return null
    try {
        return JSON.parse(user);
    } catch {
        localStorage.removeItem('user');
        return null;
    }
}

const getOrgFromBrowserStorage = () => {
    let orgSring = sessionStorage.getItem('selectedOrganization');
    if (!orgSring) return null
    
    try{
        let org = JSON.parse(orgSring);
        return org;
    }
    catch (ex){
        console.log(ex);
    }
    
    return null
}

const getOrganizationId = () => {
    let orgSring = sessionStorage.getItem('selectedOrganization');
    if (!orgSring) return null

    try{
        let org = JSON.parse(orgSring);
        return org.id;
    }
    catch (ex){
        console.log(ex);
    }

    return null
}

const isSuperView = () => {
    let orgSring = sessionStorage.getItem('selectedOrganization');
    if (!orgSring) return null

    try{
        let org = JSON.parse(orgSring);
        return org.viewingAsSuper;
    }
    catch (ex){
        console.log(ex);
    }

    return null
}

const isEnterpriseAdminOrg = () => {
    let orgSring = sessionStorage.getItem('selectedOrganization');
    if (!orgSring) return null

    try{
        let org = JSON.parse(orgSring);
        return org.isEnterpriseAdminOrg;
    }
    catch (ex){
        console.log(ex);
    }

    return null
}

const isPatient = () => {
    // Called from DashboardLayout.mounted before App.vue's async hydration has finished
    // populating localStorage. JSON.parse(null) returns null, and null.accountTypeId
    // throws — which would silently abort the caller's mounted() hook. Guard explicitly.
    const user = localStorage.getItem('user')
    if (!user) return false
    try {
        const parsed = JSON.parse(user)
        return parsed?.accountTypeId === 5
    } catch {
        return false
    }
}





export {
    getloginmethod,
    samllogin,
    ssologin,
    login,
    getUserFromBrowserStorage,
    getOrgFromBrowserStorage,
    logout,
    logoutTimeout,
    clearLogin,
    getMobileToken,
    updateAccount,
    updateAccountGroups,
    getAccounts,
    accountModel,
    updateAccountModel,
    updateAccountGroupsModel,
    getAccount,
    switchSelectedOrganization,
    isSuperView,
    isEnterpriseAdminOrg,
    newAccountModel,
    createAccount,
    getOrganizationId,
    updateAccountPasswordModel,
    updatePassword,
    checkEmailAddress,
    updateAccountInStorage,
    forgotPassword,
    resetPassword,
    deleteAccount,
    requestMfaCode,
    verifyMfaCode,
    refreshToken,
    createParentAccount,
    isPatient,
    getProfilesForAccount,
    updateAccountOrganization,
    initializePendo,
    setPendoAccount
}